import UrlPattern from 'url-pattern';
import { Language } from '@ha/intl';

const pattern = new UrlPattern('/:lang(/*)');

export function getLanguageFromUrl(url: string): Language {
  const { lang = Language.en } = pattern.match(url) || {};

  return Language[lang] || Language.en;
}
